export default __webpack_public_path__ + "static/media/tdsa-office-02.ba39aa7b.jpg";